import StackedColumn from '../../../../../../utility/generateHighChart/columnChart/StackedColumn.abstract';

class DiversityByGroup extends StackedColumn {
  isStacked = true;
}

export default DiversityByGroup;
